import authRequest from "@/api/http/authRequest";


export default {
  search (params: any, cb: (response) => void, errCb: (response) => any) {
    authRequest.get(`/admin/payment-notice/search`, params, cb, errCb)
  },
  update (params: any, cb: (response) => void, errCb: (response) => any) {
    authRequest.patch(`/admin/payment-notice/${params.id}`, params ,cb, errCb)
  },
  save (params: any, cb: (response) => void, errCb: (response) => any) {
    authRequest.post(`/admin/payment-notice`, params,cb, errCb)
  },
  delete (id: number, cb: (response) => void, errCb: (response) => any) {
    authRequest.delete(`/admin/payment-notice/${id}`, cb, errCb)
  },
}
